/**
 * InfoCity Network — Shared Portal Configuration
 * 
 * This file defines all portals in the InfoCity ecosystem.
 * Use this config for cross-navigation, ecosystem sections,
 * and future portal-to-portal communication.
 * 
 * Future: can be fetched from a shared API endpoint
 * to keep all portals in sync automatically.
 */

export const INFOCITY_PORTALS = [
  {
    key: "prop",
    name: "InfoCityProp",
    shortName: "Prop",
    description: "Real estate marketplace connecting buyers, sellers and agencies",
    url: "https://infocityprop.com",
    logo: "/logos/official/infocityprop.png",
    logoContentWidth: 885,
    color: "#028CF8",
    accentColor: "#F55FA5",
    category: "real-estate",
    active: false,
  },
  {
    key: "jobs",
    name: "InfoCityJobs",
    shortName: "Jobs",
    description: "Job marketplace connecting companies and candidates",
    url: "https://infocityjobs.com",
    logo: "/logos/official/infocityjobs.png",
    logoContentWidth: 859,
    color: "#028CF8",
    accentColor: "#F55FA5",
    category: "jobs",
    active: true, // current portal
  },
  {
    key: "cars",
    name: "InfoCityCars",
    shortName: "Cars",
    description: "Automotive marketplace for buying and selling vehicles",
    url: "https://infocitycars.com",
    logo: "/logos/official/infocitycars.png",
    logoContentWidth: 871,
    color: "#028CF8",
    accentColor: "#F55FA5",
    category: "automotive",
    active: false,
  },
  {
    key: "shop",
    name: "InfoCityShop",
    shortName: "Shop",
    description: "E-commerce marketplace for products and services",
    url: "https://infocityshop.com",
    logo: "/logos/official/infocityshop.png",
    logoContentWidth: 898,
    color: "#F55FA5",
    accentColor: "#028CF8",
    category: "ecommerce",
    active: false,
  },
  {
    key: "boat",
    name: "InfoCityBoat",
    shortName: "Boat",
    description: "Marine marketplace for boats, yachts and water sports",
    url: "https://infocityboat.com",
    logo: "/logos/official/infocityboat.png",
    logoContentWidth: 886,
    color: "#028CF8",
    accentColor: "#F55FA5",
    category: "marine",
    active: false,
  },
  {
    key: "travel",
    name: "InfoCityTravel",
    shortName: "Travel",
    description: "Travel marketplace for flights, hotels and experiences",
    url: "https://infocitytravel.com",
    logo: "/logos/official/infocitytravel.png",
    logoContentWidth: 955,
    color: "#F55FA5",
    accentColor: "#028CF8",
    category: "travel",
    active: false,
  },
];

/** Get a portal by its key */
export const getPortal = (key) => INFOCITY_PORTALS.find((p) => p.key === key);

/** Get the current active portal */
export const getCurrentPortal = () => INFOCITY_PORTALS.find((p) => p.active);

/** Get all portals except the current one */
export const getOtherPortals = () => INFOCITY_PORTALS.filter((p) => !p.active);

export default INFOCITY_PORTALS;
